module.exports = __webpack_public_path__ + "img/LeastDiscontentActive.f53e5edd.png";